function StickyScroll()
{
	var self 	= this,
		$window	= $(window),
		$header = $('header');
		
	self.ready = function()
	{
		$window.scroll(function() {
			self.update();
		});

		self.update();
	};

	self.update = function()
	{
		if($window.scrollTop()>=50){
			$header.addClass('scrolled');
		} else {
			$header.removeClass('scrolled');
		}
	}

	ApplicationObject.call( this );
}
StickyScroll.prototype = Object.create( ApplicationObject.prototype );